import ErrorHandler from '@/ErrorHandler';
import API from '@/org-app/api';
import { createGetAllAction } from '@/utils/ActionsUtils';
import i18n from '@/vueI18n';

import * as types from './mutation-types';

export default {
  getAvailsImport: createGetAllAction(
    API.instance.getAvailsImport,
    types.UPDATE_AVAILSIMPORT_LIST,
    'messages.failedToGetAvailsFiles',
    true,
  ),

  async uploadAvailsFile({ commit }, { file }) {
    try {
      return await API.instance.uploadAvailsFile({ file });
    } catch (e) {
      console.log(e, 'e');
      const msg = i18n.global.t('messages.failedToSaveNewAvailsFile');
      ErrorHandler.showError(msg, e);
    }
  },
};
